














































import { Vue, Component, Watch } from 'vue-property-decorator';
import VoteButton from './components/VoteButton.vue';
import SyPlayer from '@/components/SyPlayer.vue';
import * as config from './config';
import { prizeDetail } from './api';
import { ImagePreview } from 'vant';
// import { appShare, wxShareInfo } from '@/common/ts/common';

Vue.use(ImagePreview);
@Component({
  name: 'JTYMDetail',
  components: {
    VoteButton,
    SyPlayer,
  },
})
export default class Detail extends Vue {
  option = config.OPTHINES;
  detailData: any = {};
  show: boolean = false;
  button: boolean = true;
  // images: string[] = [this.detailData.cover];
  get images() {
    return [this.detailData.cover];
  }
  get source() {
    if (this.$route.query.source) {
      return this.$route.query.source;
    } else {
      return '';
    }
  }
  @Watch('$route')
  onRouteChange() {
    this.fetchDetail();
  }
  created() {
    this.fetchDetail();
  }
  destroyed() {
    (document.querySelector('body') as HTMLBodyElement).classList.remove(
      'dplayer-web-fullscreen-fix',
    );
  }
  async fetchDetail() {
    const res = await prizeDetail({ id: this.$route.query.id });
    this.detailData = res.data;
    if (res.data.project_type === '西洋画') {
      this.detailData.project_type = '西画';
    }
  }
  handleSuccess(num: string) {
    this.detailData.votes = num;
    this.button = false;
    setTimeout(() => {
      this.button = true;
    }, 1000);
  }

  handleClickImg() {
    this.show = true;
  }
}
